import React, { useMemo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Formik, Form, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import QueryString from 'qs';

import { I18n } from 'i18n';
import {
  Input,
  SubmitButton,
  CleanCenteredPage,
  useToast,
  PasswordInput,
} from 'components';
import { useResetPassword } from '@app/api';

const initialValues = { password: '', passwordRepeat: '' };

export const ChangeForgottenPassword = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const navigate = useNavigate();
  const { mutateAsync: resetPassword } = useResetPassword();

  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        password: Yup.string().required(),
        passwordRepeat: Yup.string()
          .required()
          .oneOf([Yup.ref('password'), ''], t('form.errors.passwordNotMatch')),
      }),
    [t],
  );

  const params = QueryString.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const token = params.token as string;

  const sendForgottenPasswordEmail = async (
    values: typeof initialValues,
    formikHelpers: FormikHelpers<typeof initialValues>,
  ) => {
    try {
      await resetPassword({ password: values.password, token });
      navigate('../change-success');
    } catch (e) {
      formikHelpers.setStatus(e);
      toast.exception(e);
    }
    formikHelpers.setSubmitting(false);
  };

  return (
    <CleanCenteredPage
      withPrevious
      title={t('forgottenPassword.changePassword.title')}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={sendForgottenPasswordEmail}
        validationSchema={validationSchema}
      >
        <Form>
          <PasswordInput
            label={t('forgottenPassword.changePassword.newPassword.label')}
            placeholder={t(
              'forgottenPassword.changePassword.newPassword.placeholder',
            )}
            name="password"
          />
          <Input
            label={t('forgottenPassword.changePassword.passwordRepeat.label')}
            placeholder={t(
              'forgottenPassword.changePassword.passwordRepeat.placeholder',
            )}
            name="passwordRepeat"
            type="password"
          />
          <SubmitButton>
            <Trans i18nKey="forgottenPassword.changePassword.submit" />
          </SubmitButton>
        </Form>
      </Formik>
    </CleanCenteredPage>
  );
};
